import { motion } from "framer-motion";
import { MailCheck } from "lucide-react";
import { fadeInUp, transition } from "@/utils/motion";

const UnverifiedView = ({ email, resending, onResend, onBack }) => (
  <div className="max-w-md mx-auto px-6 py-16" data-testid="unverified-page">
    <motion.div {...fadeInUp} transition={transition} className="hud-card clip-corners p-8 text-center">
      <MailCheck className="h-12 w-12 text-yellow-400 mx-auto mb-4" />
      <h1 className="font-headings text-2xl uppercase tracking-widest text-yellow-400 mb-2">Email Not Verified</h1>
      <p className="text-sm text-gray-400 mb-4">
        Your account exists but the email hasn&apos;t been verified yet. Check your inbox for the verification link.
      </p>
      <p className="font-data text-yellow-400 text-sm mb-6">{email}</p>
      <button
        onClick={() => onResend(email)}
        disabled={resending}
        className="w-full bg-yellow-500 text-black font-headings uppercase tracking-widest py-3 hover:bg-yellow-400 disabled:opacity-40 mb-4"
        data-testid="resend-unverified-button"
      >
        {resending ? "Sending..." : "Resend Verification Email"}
      </button>
      <button onClick={onBack} className="text-xs text-gray-500 hover:text-white" data-testid="unverified-back">
        Back to sign in
      </button>
    </motion.div>
  </div>
);

export default UnverifiedView;
